<!-- 
  from https://svelte.dev/repl/26eb44932920421da01e2e21539494cd?version=3.32.3 
  
  USAGE:
  <script>
    import MediaQuery from "./MediaQuery.svelte";

    function onChange( event ){
      console.log( event.detail.query, event.detail.matches );
    }
  </script>
  <MediaQuery query="(min-width: 481px) and (max-width: 1280px)" let:matches bind:matches={myBool} on:change={onChange} on:match={onMatch} on:unmatch={onUnmatch}>
    {#if matches}
    <div class="root tablet">
      tablet
    </div>
    {/if}
  </MediaQuery>
-->

<script>
    import { onMount } from "svelte";
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    export let query;
    export let matches = false;

    let mql;
    let mqlListener;
    let wasMounted = false;

    onMount(() => {
        wasMounted = true;
        return () => {
            removeActiveListener();
        };
    });

    $: {
        if (wasMounted) {
            removeActiveListener();
            addNewListener(query);
        }
    }

    mqlListener = function(){
      matches = mql.matches

      let eventDetail = {
        query: query,
        matches: matches
      }

      dispatch('change', eventDetail)
      if( matches )
        dispatch('match', eventDetail)
      else 
        dispatch('unmatch', eventDetail)
    }

    function addNewListener(query) {
        mql = window.matchMedia(query);
        mql.addEventListener('change', mqlListener);
        mqlListener();
    }

    function removeActiveListener() {
        if (mql && mqlListener) {
            mql.removeListener(mqlListener);
        }
    }
</script>

<slot {matches} />
